import { FC, ReactNode } from 'react'

const TableHeader: FC<TableComponentProps> = (props): ReactNode => {
    const { headers } = props

    return (
        <thead className='text-xs text-gray-700 uppercase overflow-hidden bg-[#404040]'>
            <tr>
                {
                    headers?.map((header: string, index: number) => {
                        const isFirst = index === 0

                        return (
                            <th key={index} scope='col' className={`px-6 py-3 text-[#CDD5DA] ${isFirst ? 'text-start w-full' : 'text-end w-[20%]'}`}>
                                {header}
                            </th>
                        )
                    })
                }
            </tr>
        </thead>
    )
}

export default TableHeader
